document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.announcement-bar__slider');
  if (!slider) return;

  const slides = [...slider.querySelectorAll('.announcement-bar__slide')];
  if (slides.length === 0) return;

  // Collect all text content from slides
  const texts = slides.map(s => s.querySelector('.announcement-bar__text')?.innerHTML || '');

  // Build ticker with duplicated content for seamless loop
  const ticker = document.createElement('div');
  ticker.className = 'announcement-bar-ticker';

  // Duplicate twice for seamless infinite scroll
  [...texts, ...texts].forEach(text => {
    const item = document.createElement('div');
    item.className = 'announcement-bar-ticker__item';
    item.innerHTML = text;
    ticker.appendChild(item);
  });

  // Replace slider contents
  slider.innerHTML = '';
  slider.appendChild(ticker);
});
